import { render, staticRenderFns } from "./ParentWrapper.vue?vue&type=template&id=09dfee2e&scoped=true&"
import script from "./ParentWrapper.vue?vue&type=script&lang=js&"
export * from "./ParentWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dfee2e",
  null
  
)

export default component.exports